module.exports = __webpack_public_path__ + "static/header-0f0c155c0eec2fd26aaf4faad57e43af.jpg";